import React, { useState } from 'react';
import { AlertTriangle, CheckCircle2, Calendar } from 'lucide-react';
import { useDataStore } from '../../context/DataStoreContext';
interface QaRubricProps {
  leadId: string;
  leadName: string;
  setterName: string;
  onSaved?: () => void;
}
export function QaRubric({
  leadId,
  leadName,
  setterName,
  onSaved
}: QaRubricProps) {
  const {
    createQaRecord
  } = useDataStore();
  const [scores, setScores] = useState({
    apertura: 3,
    necesidad: 2,
    objeciones: 3,
    cierre: 4,
    registro: 4
  });
  const [feedback, setFeedback] = useState('');
  const [saved, setSaved] = useState(false);
  const totalScore = Object.values(scores).reduce((a, b) => a + b, 0);
  const isRemediationRequired = totalScore < 14;
  const handleScoreChange = (item: keyof typeof scores, value: number) => {
    setScores(prev => ({
      ...prev,
      [item]: value
    }));
  };
  const handleSave = () => {
    createQaRecord({
      leadId,
      date: new Date().toISOString(),
      score: totalScore,
      notes: feedback
    });
    setSaved(true);
    setTimeout(() => {
      setSaved(false);
      if (onSaved) onSaved();
    }, 2000);
  };
  const rubricItems = [{
    id: 'apertura' as const,
    label: 'Apertura / Hook',
    desc: 'Claridad, tono, captar atención en 30s'
  }, {
    id: 'necesidad' as const,
    label: 'Identificación Necesidad',
    desc: 'Preguntas correctas, escucha activa'
  }, {
    id: 'objeciones' as const,
    label: 'Manejo Objeciones',
    desc: 'Respuestas a "no tengo tiempo", "ya tengo web"'
  }, {
    id: 'cierre' as const,
    label: 'Cierre Micro-acuerdo',
    desc: 'Llamado a la acción claro, confirmación'
  }, {
    id: 'registro' as const,
    label: 'Registro CRM',
    desc: 'Evidencia completa, campos correctos'
  }];
  return <div className="card overflow-hidden" data-id="element-703">
      <div className="p-5 border-b border-white/5 flex justify-between items-center bg-growthly-panel" data-id="element-704">
        <div data-id="element-705">
          <h3 className="text-[18px] font-semibold text-growthly-text" data-id="element-706">
            Evaluación QA
          </h3>
          <p className="text-[13px] text-growthly-muted mt-1" data-id="element-707">
            Lead:{' '}
            <span className="font-medium text-growthly-text" data-id="element-708">{leadName}</span> •
            Setter:{' '}
            <span className="font-medium text-growthly-text" data-id="element-709">{setterName}</span>
          </p>
        </div>
        <div className="text-right" data-id="element-710">
          <div className="text-[30px] font-bold text-growthly-text leading-none" data-id="element-711">
            {totalScore}
            <span className="text-[18px] text-growthly-muted font-normal" data-id="element-712">
              /20
            </span>
          </div>
          <div className={`text-[12px] font-medium mt-1 ${isRemediationRequired ? 'text-growthly-red' : 'text-growthly-green'}`} data-id="element-713">
            {isRemediationRequired ? 'Requiere Remediación' : 'Aprobado'}
          </div>
        </div>
      </div>

      {isRemediationRequired && <div className="bg-growthly-red/10 border-b border-growthly-red/30 p-4 flex items-start" data-id="element-714">
          <AlertTriangle className="w-5 h-5 text-growthly-red mr-3 flex-shrink-0 mt-0.5" data-id="element-715" />
          <div data-id="element-716">
            <h4 className="text-[14px] font-semibold text-growthly-red" data-id="element-717">
              Plan de remediación requerido
            </h4>
            <p className="text-[12px] text-growthly-red/80 mt-1" data-id="element-718">
              El score es menor a 14. Se requiere programar un feedback 1:1 y
              activar coaching por 7 días.
            </p>
          </div>
        </div>}

      <div className="p-5 space-y-6" data-id="element-719">
        <div className="space-y-4" data-id="element-720">
          {rubricItems.map(item => <div key={item.id} className="flex flex-col md:flex-row md:items-center justify-between gap-4 pb-4 border-b border-white/5 last:border-0 last:pb-0" data-id="element-721">
              <div className="flex-1" data-id="element-722">
                <h4 className="text-[14px] font-medium text-growthly-text" data-id="element-723">
                  {item.label}
                </h4>
                <p className="text-[12px] text-growthly-muted mt-1" data-id="element-724">
                  {item.desc}
                </p>
              </div>
              <div className="flex space-x-2" data-id="element-725">
                {[0, 1, 2, 3, 4].map(val => <button key={val} onClick={() => handleScoreChange(item.id, val)} className={`w-8 h-8 rounded flex items-center justify-center text-[13px] font-medium transition-colors ${scores[item.id] === val ? 'bg-growthly-green text-white' : 'bg-white/5 text-growthly-muted hover:bg-white/10 hover:text-growthly-text'}`} data-id="element-726">
                    {val}
                  </button>)}
              </div>
            </div>)}
        </div>

        <div data-id="element-727">
          <label className="block text-[13px] font-medium text-growthly-text mb-2" data-id="element-728">
            Acciones de mejora (1-3 items)
          </label>
          <textarea value={feedback} onChange={e => setFeedback(e.target.value)} rows={3} placeholder="Ej: 1. Mejorar el tono en la apertura. 2. No interrumpir al cliente..." className="input-field resize-none" data-id="element-729" />
        </div>

        <div className="flex justify-end space-x-3 pt-4 border-t border-white/5" data-id="element-730">
          <button className="btn-secondary inline-flex items-center" data-id="element-731">
            <Calendar className="w-4 h-4 mr-2" data-id="element-732" />
            Agendar 1:1 (≤72h)
          </button>
          <button onClick={handleSave} disabled={saved} className={`btn-primary inline-flex items-center ${saved ? 'bg-growthly-green' : ''}`} data-id="element-733">
            <CheckCircle2 className="w-4 h-4 mr-2" data-id="element-734" />
            {saved ? 'Guardado' : 'Guardar Evaluación'}
          </button>
        </div>
      </div>
    </div>;
}